module.exports = __webpack_public_path__ + "img/53.b6c4dd7d.jpg";